export class WsResponse {
  data: any;
  received: number;
  type: string;

  constructor() {
    this.received = new Date().getTime();
  }

}

export class WsSendEvent {
  data: any;
  type: string;
}
